// "What size am I?" — recommends frame sizes from Trek's rider-height chart and can select one
// in the product's variant picker. Data comes from the block's <script data-sizes> JSON.
class AcFitFinder extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    try {
      this.sizes = JSON.parse(this.querySelector('[data-sizes]').textContent);
    } catch {
      return;
    }
    this.addEventListener('change', () => this.update());
    this.addEventListener('click', (e) => {
      const select = e.target.closest('[data-select]');
      if (select) this.choose(select.dataset.size);
    });
    this.update();
  }

  heightCm() {
    const ft = Number(this.querySelector('[data-ft]').value);
    const inch = Number(this.querySelector('[data-in]').value);
    return Math.round((ft * 12 + inch) * 2.54);
  }

  update() {
    const cm = this.heightCm();
    const fits = this.sizes.filter((s) => cm >= s.lo && cm <= s.hi).map((s) => s.size);
    const result = this.querySelector('[data-result]');
    const inline = this.querySelector('[data-inline]');
    const button = this.querySelector('[data-select]');
    if (!fits.length) {
      const all = this.sizes.map((s) => s.lo).concat(this.sizes.map((s) => s.hi));
      const tooShort = cm < Math.min(...all);
      result.textContent = tooShort
        ? 'Below this model\'s size range. Ask us about smaller frames or kids\' bikes.'
        : 'Above this model\'s size range. Ask us about larger frames.';
      inline.textContent = '';
      button.hidden = true;
      return;
    }
    const pick = fits[0];
    result.innerHTML = fits.length > 1
      ? `You're between <strong>${fits.join(' and ')}</strong>. Most riders go smaller for agility, larger for stretch; we'll confirm at your fit.`
      : `We recommend <strong>${pick}</strong>.`;
    inline.textContent = fits.join(' / ');
    button.hidden = false;
    button.dataset.size = pick;
    button.textContent = `Select ${pick}`;
  }

  choose(size) {
    const scope = this.closest('product-form-component, .product-details, section') || document;
    const option = this.dataset.option;
    const radio = [...scope.querySelectorAll('input[type="radio"]')]
      .find((i) => i.value === size && (!option || i.dataset.optionName === option));
    if (radio) {
      radio.click();
      return;
    }
    const sel = [...scope.querySelectorAll('select')].find((s) => [...s.options].some((o) => o.textContent.trim() === size));
    if (sel) {
      const opt = [...sel.options].find((o) => o.textContent.trim() === size);
      sel.value = opt.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

if (!customElements.get('ac-fit-finder')) customElements.define('ac-fit-finder', AcFitFinder);
